import { useCurrency } from "@/hooks/use-currency";

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  GBP: "£",
  EUR: "€",
  JPY: "¥",
  PHP: "₱",
  THB: "฿",
  VND: "₫",
  MYR: "RM",
  IDR: "Rp",
  SGD: "S$",
};

/** @deprecated use useCurrency instead; use a Intl.NumberFormat too */
export const useCurrentCurrency = (): string => {
  const currency = useCurrency();
  return CURRENCY_SYMBOLS[currency] ?? "$";
};
